import { FormControl } from '@angular/forms';

import { FieldAtomic, FieldValueObject, FieldValue, addFieldValue } from './field';

export class FieldNumberCst extends FieldAtomic<number> {
	private aValue: number | undefined;

	constructor(
		name: string,
		originalValue: number | undefined,
		value: number | undefined
	) {
		super(false, 'numberCst', name, originalValue);
		this.aValue = value;
	}

	value() {
		return this.aValue;
	}

	collectVarValue() {
		// noop
	}

	setValue(value: FieldValue) {
		if (value === undefined || typeof value === 'number') {
			this.aValue = value;
			return;
		}
		throw new Error(`unable to set value; expected number, but found ${ JSON.stringify(value) }`);
	}
}

export class FieldNumberVar extends FieldAtomic<number> {
	readonly path: string;
	readonly control: FormControl;
	readonly integerCount: number;
	readonly decimalCount: number;
	readonly stepValue: number;
	readonly maxValue: number;
	readonly minValue: number;

	constructor(
		name: string,
		path: string,
		originalValue: number | undefined,
		value: number | undefined,
		integerCount: number,
		decimalCount: number,
		maxValue?: number,
		minValue?: number
	) {
		super(true, 'numberVar', name, originalValue);
		this.path = path;
		this.control = new FormControl(value);
		this.integerCount = integerCount;
		this.decimalCount = decimalCount;
		this.stepValue = 10 ** -decimalCount;
		this.maxValue = maxValue === undefined ? (10 ** integerCount) - this.stepValue : maxValue;
		this.minValue = minValue === undefined ? 0 : minValue;
	}

	value() {
		const value = <string | number | undefined> this.control.value;
		return value || value === 0 ? Number(value) : undefined;
	}

	collectVarValue(object: FieldValueObject) {
		addFieldValue(this.path, this.value(), object);
	}

	setValue(value: FieldValue) {
		if (value === undefined || typeof value === 'number') {
			this.control.setValue(value);
			return;
		}
		throw new Error(`unable to set value; expected number, but found ${ JSON.stringify(value) }`);
	}
}
